import {MDCSelect} from "@material/select";

$(document).on("turbolinks:load", function () {
  
  var stateSelectElement = document.querySelector("div.mdc-select[data-element-type='state_id']");
  var citySelectElement = document.querySelector("div.mdc-select[data-element-type='city_id']");
  var schoolSelectElement = document.querySelector("div.mdc-select[data-element-type='school_id']");

  if (stateSelectElement) {
    var stateSelect = new MDCSelect(stateSelectElement);
    var citySelect = new MDCSelect(citySelectElement);
    var schoolSelect = new MDCSelect(schoolSelectElement);
    console.log($("div.mdc-select[data-element-type='state_id']").val());
    setupSchoolMenuList(stateSelect, citySelect, schoolSelect);
  }

  $(document).on('click', '[data-element-type="campaign"]', function () {
    $(".campaign-card").removeClass("selected")
    let campaignId = $(this).attr('data-campaign-id');
    let campaignCard = $(`#campaign-${campaignId}`)
    campaignCard.toggleClass('selected')
  })

  $('#new-campaign-cancel-link').on('click', function(event) {
    event.preventDefault();
    resetForm();
  });

  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const token = params.get('token');
  if (token && $(".register-to-new-campaign-container").length > 0) {

    $("div.mdc-select[data-element-type='state_id']").addClass('mdc-select--disabled')
    $("div.mdc-select[data-element-type='city_id']").addClass('mdc-select--disabled')
    $("div.mdc-select[data-element-type='school_id']").addClass('mdc-select--disabled')

    var joinSubmitButton = document.getElementById('new-campaign-join-submit');
    joinSubmitButton.disabled = false;
  }
});

function setupSchoolMenuList(stateSelect, citySelect, schoolSelect) {
  if (typeof itemCollections !== undefined) {
    stateSelect.listen('MDCSelect:change', function (data) {
      fillCityMenuList(data.detail.value, citySelect.menu.list_.root, itemCollections.cities);
      enableJoinSubmitButton()
    });

    citySelect.listen('MDCSelect:change', function (data) {
      fillOrganizationMenuList(data.detail.value, schoolSelect.menu.list_.root, itemCollections.organizations);
      enableJoinSubmitButton()
    });

    schoolSelect.listen('MDCSelect:change', function (data) {
      enableJoinSubmitButton()
    });
  }
}

function fillCityMenuList(stateId, $select, collection) {
  resetDropDown('city_id')
  var options = collection[stateId.toString()] || [];
  fillMenuList($select, options, 'city', 'city');
}

function fillMenuList($select, options, key, value) {
  removeMenuListChildren($select);
  options.forEach(option => {
    var row = `<li class="mdc-list-item" data-value="${option[key]}" role="option" tabindex="0">${option[value]}</li>`;
    $select.insertAdjacentHTML('beforeend', row);
  });
}

function removeMenuListChildren($select) {
  var $oldChildren = $($select).find('li');
  $oldChildren.remove();
}

function fillOrganizationMenuList(cityName, $select, collection) {
  resetDropDown('school_id')
  var options = collection[cityName.toString()] || [];
  fillMenuListWithDataAttr($select, options, 'id', 'name', 'is_club');
}

function resetForm() {
  resetDropDown('state_id')
  resetDropDown('city_id')
  resetDropDown('school_id')
}

function resetDropDown(elementType){
  // Reset the selected value
  $(`div[data-element-type="${elementType}"] .mdc-select__hidden-input`).val('');
  $(`input[name="${elementType}"]`).val('');
  // Clear the selected text
  $(`div[data-element-type="${elementType}"] .mdc-select__selected-text`).text('');
  // Reset the floating label
  $(`div[data-element-type="${elementType}"] .mdc-floating-label`).removeClass('mdc-floating-label--float-above');
}

function enableJoinSubmitButton() {
  var joinSubmitButton = document.getElementById('new-campaign-join-submit');
  var stateSelected = $('input[name="state_id"]').val().trim() !== '';
  var citySelected = $('input[name="city_id"]').val().trim() !== '';
  var schoolSelected = $('input[name="school_id"]').val().trim() !== '';
  if (stateSelected && citySelected && schoolSelected) {
    joinSubmitButton.disabled = false;
  } else {
    joinSubmitButton.disabled = true;
  }
}

function fillMenuListWithDataAttr($select, options, key, value, data) {
  removeMenuListChildren($select);
  options.forEach(option => {
    var row = `<li class="mdc-list-item" data-value="${option[key]}" data-${data}="${option[data]}" tabindex="0">${option[value]}</li>`;
    $select.insertAdjacentHTML('beforeend', row);
  });
}

function loadCampaigns(schoolId) {
  schoolId = "En5Sd0"
  Rails.ajax({
    type: "GET",
    url: `/v2/schools/${schoolId}/campaigns/available`,
    success: (response) => {
      console.log(response)

    },
    error: (response) => {
      const {message, errors} = response
    }
  })
}
